<template>
  <div class="bids-action">
    <ElDropdown trigger="click" class="pointer" @command="handleCommand">
      <span class="el-dropdown-link">
        <StrokeButton size="mini" type="primary" plain>
          {{ $tc('ADVERTISEMENT.BIDS.ACTION_BUTTON', countSelected) }}
          <i class="el-icon-arrow-down el-icon--left" />
        </StrokeButton>
      </span>
      <ElDropdownMenu slot="dropdown">
        <ElDropdownItem command="delete" :disabled="!hasSelection">
          {{ $tc('ADVERTISEMENT.BIDS.ACTION_REMOVE', countSelected) }}
        </ElDropdownItem>
        <ElDropdownItem command="edit" divided :disabled="!hasSelection">
          {{ $tc('ADVERTISEMENT.BIDS.EDIT_SELECTED_BIDS', countSelected) }}
        </ElDropdownItem>
        <ElDropdownItem :disabled="hasSelection" command="edit">
          {{ $t('ADVERTISEMENT.BIDS.EDIT_ALL_BIDS') }}
        </ElDropdownItem>
        <ElDropdownItem command="enable" :disabled="!hasSelection" divided>
          <i class="material-icons bids-actions__item-icon">play_arrow</i>
          {{ $tc('ADVERTISEMENT.BIDS.ACTION_ACTIVATE', countSelected) }}
        </ElDropdownItem>
        <ElDropdownItem command="disable" :disabled="!hasSelection">
          <i class="material-icons bids-actions__item-icon">pause</i>
          {{ $tc('ADVERTISEMENT.BIDS.ACTION_PAUSE', countSelected) }}
        </ElDropdownItem>
      </ElDropdownMenu>
    </ElDropdown>

    <EditBidPriceOfferModal
      v-model="editPriceOffer"
      :selected-ids="selectedIds"
    />
  </div>
</template>

<script>
import EditBidPriceOfferModal from './EditBidPriceOfferModal';

import StrokeButton from '@@/advertisement/common/StrokeButton';

import { mapActions } from 'vuex';
import { DELETE_CAMPAIGN_BIDS, CHANGE_BIDS_STATUS } from '@/store/types';

import campaignId from '@/mixins/advertisement/campaignId';

export default {
  name: 'BidsListWrapperActions',
  components: {
    EditBidPriceOfferModal,
    StrokeButton,
  },
  mixins: [campaignId],
  props: {
    selectedIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      editPriceOffer: false,
    };
  },
  computed: {
    countSelected() {
      return this.selectedIds.length;
    },
    hasSelection() {
      return Boolean(this.countSelected);
    },
  },
  methods: {
    ...mapActions({
      deleteBids: DELETE_CAMPAIGN_BIDS,
      changeBidsStatus: CHANGE_BIDS_STATUS,
    }),
    deleteBidsFromStore() {
      return this.deleteBids({
        ids: this.selectedIds,
        campaignId: this.campaignId,
      })
        .then(() => {
          this.$message.success(this.$t('ADVERTISEMENT.BID.DELETE_SUCCESS'));
          this.$emit('delete');
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
    deleteWithConfirm() {
      return this.$confirm(this.$t('DELETE_ITEM_WARNING'), this.$t('WARNING'), {
        confirmButtonText: this.$t('DELETE_IT'),
        cancelButtonText: this.$t('CANCEL'),
        cancelButtonClass: 'el-button--text is-plain',
        type: 'danger',
      })
        .then(() => {
          this.deleteBidsFromStore();
        })
        .catch(() => {
          // As there is nothing to do with this,
          // I only want to specify a function to handle
          // an unhandled promise rejection
        });
    },
    enableBids() {
      return this.changeBidsStatus({
        campaignId: this.campaignId,
        ids: this.selectedIds,
        paused: false,
      })
        .then(message => {
          this.$message.success(message);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
    disableBids() {
      return this.changeBidsStatus({
        campaignId: this.campaignId,
        ids: this.selectedIds,
        paused: true,
      })
        .then(message => {
          this.$message.success(message);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
    showEditBidModal() {
      this.editPriceOffer = true;
    },
    handleCommand(command) {
      switch (command) {
        case 'delete':
          this.deleteWithConfirm();
          break;
        case 'edit':
          this.showEditBidModal();
          break;
        case 'enable':
          this.enableBids();
          break;
        case 'disable':
          this.disableBids();
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.bids-actions {
  &__item-icon {
    font-size: rem-calc(16px);

    margin-right: $global-margin / 4;
    @include rtl() {
      margin-left: $global-margin / 4;
      margin-right: 0;
    }
  }
}
</style>
